module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Cookie-e17e0ecf24e4e1713347b5d819245bb08605b65f8b5861409bdc19731c64658e.svg";